import React from 'react';
import PropTypes from 'prop-types';

export const Select = (props) => {
  const { input, meta, styles } = props;
  const { name } = input;
  let inputStyles = ["form-control"];
  const parentDivStyles = ["form-group"];
  const ariaDescription = `Barclaycard CL Apply Application-sr-description`;

  if (styles) {
    inputStyles = inputStyles.concat(styles.input);
  }

  let ariaDescriptionExists = false;
  let errorMarkup = null;

  if (meta.touched && meta.error && !meta.active) {
    inputStyles.push("is-invalid");
    parentDivStyles.push("is-invalid-field");
    ariaDescriptionExists = true;
    errorMarkup = (<div id={ariaDescription} className="invalid-feedback">{meta.error}</div>);
  }

  return (
    <div className={parentDivStyles.join(' ')}>
      <label
        className="label dirty"
        htmlFor={name}
      >
        {props.label}
      </label>
      <select
        id={name}
        placeholder={props.placeholder}
        className={inputStyles.join(' ')}
        aria-describedby={ariaDescriptionExists ? ariaDescription : undefined}
        aria-invalid={ariaDescriptionExists}
        required={props.required}
        disabled={props.disabled}
        {...input}
      >
        {props.children}
      </select>
      {errorMarkup}
    </div>);
};

const validateAgainstOptionList = (props, propName, componentName) =>
  props[propName].type.name.endsWith('OptionList')
    ? null
    : new Error(`Invalid prop ${propName} supplied to ${componentName}.`);

Select.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    active: PropTypes.bool,
    error: PropTypes.string
  }),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    validateAgainstOptionList
  ]).isRequired
};

export default Select;
